"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeedOfDarknessEffectHandler = exports.SeedOfDarknessEffectArgs = void 0;
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class SeedOfDarknessEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.SeedOfDarkness;
        this.__typeName = "SeedOfDarkness";
        this.name = "SeedOfDarkness";
        this.harmful = true;
    }
}
exports.SeedOfDarknessEffectArgs = SeedOfDarknessEffectArgs;
let SeedOfDarknessEffectHandler = class SeedOfDarknessEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerIds = [
            container.registerEventHandlerScript(state.targetId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), "Effect_SeedOfDarkness_OnTargetKilledOrTick", {
                createdBy: state.creatorId,
                effectId: state.id
            }),
            container.registerEventHandlerScript(state.targetId, EventType_1.EventType.Tick, Schedule_1.Schedule.Combined(8, 1), "Effect_SeedOfDarkness_OnTargetKilledOrTick", {
                createdBy: state.creatorId,
                effectId: state.id
            })
        ];
    }
    remove(sequence, container, state) {
        (state.meta.eventHandlerIds || []).forEach(id => container.cancelEventHandler(id));
    }
};
SeedOfDarknessEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.SeedOfDarkness)
], SeedOfDarknessEffectHandler);
exports.SeedOfDarknessEffectHandler = SeedOfDarknessEffectHandler;
